import { render, staticRenderFns } from "./v2.vue?vue&type=template&id=2bdd98b2&scoped=true&"
import script from "./v2.vue?vue&type=script&lang=ts&"
export * from "./v2.vue?vue&type=script&lang=ts&"
import style0 from "./v2.vue?vue&type=style&index=0&id=2bdd98b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd98b2",
  null
  
)

export default component.exports